import type { FunctionComponent, ReactNode } from 'react';
import { useMemo, useReducer } from 'react';

import SeedFailedOrdersContext from './SeedFailedOrdersContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';

const SeedFailedOrdersProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <SeedFailedOrdersContext.Provider value={{ actions, state }}>
      {children}
    </SeedFailedOrdersContext.Provider>
  );
};

export default SeedFailedOrdersProvider;
